import React, { memo, useCallback } from 'react';

import { Box, xcss } from '@atlaskit/primitives';

import type { ContentClassificationMetadata } from '../index';
import { EditorDataClassification } from '../index';

export type DataClassificationButtonProps = {
	contentId: string;
	shouldShowHoverButton: boolean;
	userOffline: boolean;
	isCustomSitesPageTitleFFOn?: boolean;
	setIsClassificationButtonFocused?: (newValue: boolean) => void;
	setIsClassificationMenuOpen?: (newValue: boolean) => void;
	contentClassificationMetadata: ContentClassificationMetadata;
	hasClassification: boolean;
	spaceKey: string;
};

const buttonVisibleStyle = xcss({
	opacity: 1,
	height: '26px',
});

const buttonHiddenStyle = xcss({
	opacity: 0,
});

const dataClassificationHoverButtonBoxStylesPadding0 = xcss({
	padding: 'space.0',
});

export const DataClassificationHoverButton = memo(
	({
		contentId,
		shouldShowHoverButton,
		userOffline,
		isCustomSitesPageTitleFFOn = false,
		setIsClassificationMenuOpen,
		setIsClassificationButtonFocused,
		contentClassificationMetadata,
		hasClassification,
		spaceKey,
	}: DataClassificationButtonProps) => {
		const handleFocus = useCallback(() => {
			if (!isCustomSitesPageTitleFFOn && setIsClassificationButtonFocused) {
				setIsClassificationButtonFocused(true);
			}
		}, [setIsClassificationButtonFocused, isCustomSitesPageTitleFFOn]);

		const handleBlur = useCallback(() => {
			if (!isCustomSitesPageTitleFFOn && setIsClassificationButtonFocused) {
				setIsClassificationButtonFocused(false);
			}
		}, [setIsClassificationButtonFocused, isCustomSitesPageTitleFFOn]);

		if (hasClassification) {
			return null;
		}

		return (
			<Box
				xcss={[
					shouldShowHoverButton ? buttonVisibleStyle : buttonHiddenStyle,
					!isCustomSitesPageTitleFFOn && dataClassificationHoverButtonBoxStylesPadding0,
				]}
				testId="data-classification-button-wrapper"
				onFocus={handleFocus}
				onBlur={handleBlur}
			>
				<EditorDataClassification
					contentId={contentId}
					userOffline={userOffline}
					onClassificationMenuToggle={setIsClassificationMenuOpen}
					isCustomSitesPageTitleFFOn={isCustomSitesPageTitleFFOn}
					contentClassificationMetadata={contentClassificationMetadata}
					spaceKey={spaceKey}
				/>
			</Box>
		);
	},
);
